import { Creatable } from 'react-select';
import React from 'react';

export const LCCreatable = props => <Creatable {...props} />;
